<template>
  <div>
    <b-col cols="12" class="mt-5">
      <h3 class="title text font-weight-bold">Categorias Inativas</h3>
      <b-table
        striped
        hover
        show-empty
        empty-text="Sem categoria encontrada"
        :fields="table.headers"
        :items="data"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(category)="data">
          {{ data.item.name }}
        </template>
        <template #cell(quantity)="data">
          {{ data.item.menu_product.length }}
        </template>
        <template #cell(functions)="data">
          <b-row no-gutters>
          <b-col cols="6" class="mb-2" align-self="center">
            <b-button
              variant="outline-info"
              size="sm"
              title="Ativar"
              class="mr-2 mb-2"
              @click="activeCategory(data.item.id)"
            >
              <i class="fas fa-thumbs-up"></i>
            </b-button>
          </b-col>
          <b-col cols="6" class="mb-2" align-self="center">
            <b-button
              variant="outline-warning"
              size="sm"
              title="Visualizar produtos"
              class="mr-2 mb-2"
              @click="
                      $refs.modalProductsCategoryApp.toggleOpen({
                        item: data.item,
                      })
                    "
            >
              <i class="fas fa-eye"></i>
            </b-button>
          </b-col>
          <b-col cols="6" class="mb-2" align-self="center">
            <b-button
              variant="outline-primary"
              size="sm"
              title="Editar"
              class="mr-2 mb-2"
              @click="editByCategory(data.item)"
            >
              <i class="fas fa-pen"></i>
            </b-button>
          </b-col>
          <b-col cols="6" class="mb-2" align-self="center">
            <b-button
              variant="outline-success"
              size="sm"
              title="Adicionar produtos"
              class="mr-2 mb-2"
              @click="
                      $refs.modalAddProductsApp.toggleOpen({
                        item: data.item.menu_product,
                        menuId: data.item.id,
                      })
                    "
            >
              <i class="fas fa-plus"></i>
            </b-button>
          </b-col>
          </b-row>
        </template>
      </b-table>
    </b-col>
    <modalProductsCategoryApp ref="modalProductsCategoryApp" />
    <modalAddProductsApp ref="modalAddProductsApp" @getProductSelect="get()" />
  </div>
</template>
<script>
import modalProductsCategoryApp from '../products/modalProductsCategoryApp.vue';
import modalAddProductsApp from '@/views/lojista/products/modalAddProductsApp.vue';
export default {
  emits: ['activeCategory', 'editByCategory', 'getCategory'],
  components: {
    modalProductsCategoryApp,
    modalAddProductsApp
  },
  data() {
    return {
      loading: false,
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'category',
            label: 'Nome',
            sortable: true,
          },
          {
            key: 'quantity',
            label: 'Quantidade',
            sortable: true,
          },
          {
            key: 'functions',
            label: 'Funções',
            thStyle: 'width: 110px;',
            tdStyle: 'width: 110px;'
          },
        ],
      }
    }
  },


  props: {
    data: {
      type: Array,
    }
  },


  methods: {
    activeCategory(id) {
      this.$emit('activeCategory', id);
    },

    editByCategory(item) {
      this.$emit('editByCategory', item);
    },

    get() {
      this.$emit('getCategory');
    }
  }
}
</script>